import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=6a7735aa&"
import script from "./ProductsTable.vue?vue&type=script&lang=js&"
export * from "./ProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7735aa')) {
      api.createRecord('6a7735aa', component.options)
    } else {
      api.reload('6a7735aa', component.options)
    }
    module.hot.accept("./ProductsTable.vue?vue&type=template&id=6a7735aa&", function () {
      api.rerender('6a7735aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant_customer/views/Dashboard/Components/ProductsTable.vue"
export default component.exports